// extracted by mini-css-extract-plugin
export default {"page":"vi-z","cartModal":"wi-z","checkout":"xi-z","placeholder":"yi-z","account":"zi-z"};